import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#today', label: '今日更新' },
  { href: '#ranking', label: '热播榜' },
  { href: '#new', label: '新片上映' },
  { href: '#theater', label: '院线同步' },
  { href: '#highrated', label: '高分推荐' },
  { href: '#genres', label: '类型浏览' },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-transparent bg-background-50/70 backdrop-blur'
      }`}
    >
      <div className="flex h-14 items-center justify-between gap-4 px-4 md:h-16 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <i className="ri-film-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">九七电影院</span>
            <span className="mt-0.5 text-[10px] tracking-wide text-foreground-600">电影资讯 · 每日更新</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="页面分区导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#today"
            className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:inline-flex"
          >
            今日看点
          </a>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端分区导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}